import React from "react";
import { Divider, Space, Table, Tag, Typography } from "antd";
import { pretty } from "utils/auditLogUtils";
import { StudentImportResult } from "types/importTypes";
import ImportResultTable from "feature-module/import/components/ImportResultTable";

const { Text, Title } = Typography;
export const StudentImportResults: React.FC<{ after: StudentImportResult }> = ({ after }) => {
  return (
    <div>
      {after && (
        <ImportResultTable
          errors={after?.errors}
          created={after?.created}
          skipped={after?.skipped}
        />
      )}
    </div>
  );
};
